import React from 'react';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';

import { VpButton } from '@vp-ui/components/VpButton';

const buttonStyles = {
  gap: '5px',
  padding: '5px 10px'
};

export const VpTabButtonGroup = ({
  first = '',
  second = '',
  third = null,
  fourth = null,
  selected = false,
  onSelect = () => {},
  ...rest
}) => {
  const isNumericMode = (third !== null && third !== undefined) || (fourth !== null && fourth !== undefined);
  
  const handleClick = (value) => {
    onSelect(value);
  };

  const calculateProps = (compareValue) =>
    compareValue === selected
      ? {
          color: 'info',
          variant: 'contained'
        }
      : {
          color: 'neutral'
        };

  return (
    <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between" {...rest}>
      <VpButton 
        onClick={() => handleClick(isNumericMode ? 0 : false)} 
        sx={buttonStyles} 
        {...calculateProps(isNumericMode ? 0 : false)}
      >
        {first}
      </VpButton>
      <VpButton 
        onClick={() => handleClick(isNumericMode ? 1 : true)} 
        sx={buttonStyles} 
        {...calculateProps(isNumericMode ? 1 : true)}
      >
        {second}
      </VpButton>
      {third && (
        <VpButton
          onClick={() => handleClick(2)}
          sx={buttonStyles}
          {...calculateProps(2)}
        >
          {third}
        </VpButton>
      )}
      {fourth && (
        <VpButton
          onClick={() => handleClick(3)}
          sx={buttonStyles}
          {...calculateProps(3)}
        >
          {fourth}
        </VpButton>
      )}
    </Stack>
  );
};

VpTabButtonGroup.propTypes = {
  first: PropTypes.node,
  second: PropTypes.node,
  third: PropTypes.node,
  fourth: PropTypes.node,
  selected: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onSelect: PropTypes.func
};

export default VpTabButtonGroup;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTabButtonGroup/VpTabButtonGroup.jsx